module.exports = __webpack_public_path__ + "static/media/mastercard.4dd13729.svg";